module.exports = __webpack_public_path__ + "static/media/s_sf_15.d649ff95.png";